<template>
  <section class="pa-section pa-section-registration">
    <div class="pa-golden-wide-box pa-notice">
      <p class="title title-double-line">新規接続申請<span class="mini">-&nbsp;ご注意事項&nbsp;-</span></p>
      <div class="content content-center">
        <p>こちらは塔経市帝２４区番外地管理局秋葉原駐在所で御座います。</p>
        <p class="break-point">異界舞踏会・アキバトリカルへの新規接続申請（新規登録）の手続きを進めさせていただきます。</p>
        <p class="break-point">異界舞踏会・アキバトリカルはバックグラウンドストーリーを備えた、シアトリカル・ソーシャルネットワーク・サービスで御座います。</p>
        <p>一般的なソーシャル・ネットワーク・サービスと異なり、バックグラウンド・ストーリーが存在し、それに基づいた演出が発生致します。</p>
        <p>演出の都合上、突発的にシステム内の一部機能が使えなくなったり、ユーザー間のコミュニケーションに支障が発生する場合がございます。</p>
        <p class="break-point">一般的なソーシャル・ネットワーク・サービスと異なる事をご了承の上ご参加くださいませ。</p>
        <p class="break-point">異界舞踏会・アキバトリカルの世界観を壊す様な行動を取られてた場合、運営者の判断により参加の継続をお断りさせて頂く場合がございます。</p>
        <p>異界舞踏会・アキバトリカル内のコンシェルジュキャラクターとのメッセージのやりとり内容は演出の都合上、一部のユーザーに開示される場合がございます。</p>
        <p>開示される可能性のあるメッセージには注意マークが付与されます。コンシェルジュキャラクターのとやり取りは十分お気をつけください。</p>
        <p class="break-point">異界舞踏会・アキバトリカルは架空の世界での日常と現実世界の日常が入り交じる世界観を持っています。</p>
        <p>「異世界」「パラレルワールド」「日常から異世界への地続きの飛び物」「魔法世界」「レトロフューチャー」「大正浪漫」「ハートフルストーリー」などのストーリーが苦手な方はご注意ください。</p>
        <p>ストーリー演出の関係上、現実の世界とシンクロした異世界のストーリーが語られる場合がございます。</p>
        <p>現実と非現実の区別の付かない方はご参加をお控え頂ますようお願いします。</p>
        <p class="break-point">異界舞踏会・アキバトリカルはＰＷＡ（プログレッシブ・ウェブ・アプリケーション）で<span class="nobr">構築されております。</span></p>
        <p>一般的なウェブサイトと異なる技術で構築されており、最新のiOS及びAndroid端末内のデフォルトブラウザからのご利用を想定致しております。</p>
        <p class="mini">（スマートフォンのＯＳバージョンが古い場合、ブラウザがＰＷＡに対応していない場合が御座います。）</p>
        <p>また、ＰＣ端末からのご利用を想定致しておりません。</p>
        <p>スマートフォン及びタブレット端末のブラウザからのご利用をお勧め致します。</p>
        <p><span class="strong">サービス内には課金コンテンツもございます。</span></p>
        <p class="has-underline">異界舞踏会・アキバトリカルへの<span class="strong strong-with-underline">登録及び、基本的なサービスは無料</span>で御利用いただけます。</p>
        <!-- <p class="mini">（課金に関しての詳細はこちらを御覧ください。）</p> -->
        <p>ご了承の上、御登録くださいませ。</p>
      </div>

      <form action="/" method="post" class="pa-front-form next-button">
        <transition name="validation-fail">
          <p class="validation_error" v-if="isFailedValidation">
            <span class="valid-error valid-wide">ご注意事項にご同意いただけない場合、ご参加いただくことはできません。</span>
          </p>
        </transition>

        <p>
          <input type="checkbox" name="registration-agree" value="yes" v-model="noticeAccepted" id="registration-agree-checkbox" />
          <label for="registration-agree-checkbox">上記に記載されている内容を理解し、同意しました。</label>
        </p>

        <input type="submit" value="旅券選択へ" class="submit-next" @click.prevent="submitSelectPassport" />
      </form>
    </div>
  </section>
</template>

<script>
import FrontPageMixins from '@/mixins/FrontPageMixins'

export default {
  mixins : [
    FrontPageMixins
  ],

  data(){
    return {
      noticeAccepted     : false,
      isFailedValidation : false,
    };
  },
  methods : {
    submitSelectPassport(){
      if(this.noticeAccepted == true){
        this.isFailedValidation = false;

        this.$router.push({name:'registration.selectPassport'});
      }else{
        this.isFailedValidation = true;
      }
    }
  },
  async mounted(){
    await this.initializePage();
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/globals.scss";

@keyframes simpleFadeIn
{
  0%   {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.validation-fail{
  &-enter-active{
    animation: simpleFadeIn 1s;
  }

  &-leave-active{
    animation: simpleFadeIn .5s reverse;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.pa-section{
  &-registration{
    .pa-notice{
      .next-button{
        text-align: center;
        margin:0 auto;
        padding:.8rem 0;
        width:80%;
        border-top:.2rem solid #D8C19C;

        label{
          margin-left:.4rem;
        }

        input.submit-next{
          -webkit-appearance: none;
          border:.3rem solid #8C7460;
          border-radius: .3rem;
          background-color:#966E53;
          color:#E5E5E5;
          font-size: 1rem;
          margin:.4rem 0;
          padding:0 1rem;
          font-weight: bold;
        }

        p.validation_error{
          margin-bottom:.4rem;
        }
      }
    }
  }
}
</style>